import React from 'react';
import './Whatsapp.css';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppChat = () => {
  const phoneNumber = '919876543210'; // Replace with your number (country code + number)

  return (
    <a
      href={'https://wa.me/+918760428938'}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp className="whatsapp-icon" />
    </a>
  );
};

export default WhatsAppChat;
